import { Pipe, PipeTransform } from "@angular/core";
import { obtenerNombreTipoEstudio, TipoEstudioEnum } from "@shared/enums";

@Pipe({
    name: "nombreTipoEstudio"
})
export class NombreTipoEstudioPipe implements PipeTransform {

    transform(tipo: TipoEstudioEnum): string {
        return obtenerNombreTipoEstudio(tipo);
    }

}
